import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import Button from '@mui/material/Button';
import chroma from 'chroma-js';
import { useCallback, useEffect, useId, useState } from 'react';
import { createGetFreeDailyBonusOutbound } from '../api/outbound/commonOutbounds';
import { useSocketSend } from '../context/webSocket/webSocketContext';
import { updateFreeDailyBonusDelay } from '../redux/actions/selfDataActions';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { CountdownTimerDisplay } from './countdownTimer/countdownTimerDisplay';
const LIGHT_COLOR = '#279a45';
const TITLE_COLOR = chroma(LIGHT_COLOR).set('hsl.l', '*2').css();
const BACKGROUND_COLOR = chroma(LIGHT_COLOR).set('hsl.l', '*0.5').css();
const COUNTDOWN_TIMER_CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  font-family: BoldTriplejackFont;
  line-height: 125%;
  background-color: ${BACKGROUND_COLOR};
  margin-bottom: 10px;
  padding: 5px;
  border-radius: 10px;
  border: 3px solid ${LIGHT_COLOR};
  color: ${LIGHT_COLOR};
  filter: drop-shadow(4px 4px 0 rgb(0, 0, 0, 0.4));
`;
const COUNTDOWN_TIMER_CSS = css `
  font-size: 125%;
  white-space: nowrap;
`;
const TITLE_CSS = css `
  color: ${TITLE_COLOR};
`;
export const FreeDailyBonusButtonContainer = () => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const freeDailyBonusAvailableTimestampMs = useAppSelector((state) => state.selfData.freeDailyBonusAvailableTimestampMs);
    const [testUpdateCount, setTestUpdateCount] = useState(0);
    const onClickGetDailyBonus = useCallback(() => {
        socketSend(createGetFreeDailyBonusOutbound());
    }, [socketSend]);
    const onTimerEnd = useCallback(() => {
        dispatch(updateFreeDailyBonusDelay(0));
    }, [dispatch]);
    useEffect(() => {
        setTestUpdateCount((currTestUpdateCount) => currTestUpdateCount + 1);
    }, [freeDailyBonusAvailableTimestampMs]);
    const id = useId();
    if (freeDailyBonusAvailableTimestampMs === -1) {
        // -1 means feature is turned off on the server or there was an error
        return null;
    }
    if (freeDailyBonusAvailableTimestampMs === undefined) {
        // free daily bonus is available now
        return (_jsx("div", { children: _jsx(Button, { variant: 'contained', color: 'secondary', onClick: onClickGetDailyBonus, startIcon: _jsx(AutoAwesomeRoundedIcon, {}), children: "Get Daily Bonus" }) }));
    }
    return (_jsxs("div", { "aria-labelledby": id, css: COUNTDOWN_TIMER_CONTAINER_CSS, "data-update-count": testUpdateCount, children: [_jsx("div", { id: id, css: TITLE_CSS, children: "Free Daily Bonus in" }), _jsx("div", { css: COUNTDOWN_TIMER_CSS, children: _jsx(CountdownTimerDisplay, { endTimestampMs: freeDailyBonusAvailableTimestampMs, digitWidth: 11, onTimerEnd: onTimerEnd }) })] }));
};
